// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1uk1a","content":"Consent_content__cnFOy","footer":"Consent_footer__IkgF9"};